import { Itinerary2 } from '~/models/Itinerary'
import { LeadDashboard } from '~/models/LeadDashboard'
import { LeadService } from '~/passporter-services/lead/service'
import { LeadDashboardService } from '~/services/lead/service'

export class LeadActions {
	static async createTrip(leadId: string): Promise<Itinerary2> {
		return await LeadService.createTrip(leadId)
	}

	static async getDashboard(leadId: string): Promise<LeadDashboard> {
		try {
			return await LeadDashboardService.getDashboard(leadId)
		} catch (error) {
			console.error(error)
			return {} as LeadDashboard
		}
	}
}
